import type { PropsWithChildren, ReactNode } from 'react';
import { styled } from '@epihub/web/src/_ctx/theme';

type Props = {
  background: ReactNode;
};

export const OverlayComponent = ({ children, background }: PropsWithChildren<Props>) => {
  return (
    <Root>
      <Absolute>
        <Container>
          {background}
        </Container>
      </Absolute>
      <Static>
        {children}
      </Static>
    </Root>
  );
};

const Root = styled.div`
  position: relative;
`;

const Absolute = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  position: relative;
`;

const Static = styled.div`
`;
